export const CATEGORIES = [
  {
    name: 'Accountants',
    type: 'accounting',
    dir: 'accountants'
  },
  {
    name: 'ATMs',
    type: 'atm',
    dir: 'atms'
  },
  {
    name: 'Bakeries',
    type: 'bakery',
    dir: 'bakeries'
  },
  {
    name: 'Banks',
    type: 'bank',
    dir: 'banks'
  },
  {
    name: 'Pubs',
    type: 'bar',
    dir: 'pubs'
  },
  {
    name: 'Beauty salons',
    type: 'beauty_salon',
    dir: 'beauty-salons'
  },
  {
    name: 'Casinos',
    type: 'casino',
    dir: 'casinos'
  },
  {
    name: 'Cafes',
    type: 'cafe',
    dir: 'cafes'
  },
  {
    name: 'Car dealers',
    type: 'car_dealer',
    dir: 'car-dealers'
  },
  {
    name: 'Car repair',
    type: 'car_repair',
    dir: 'car-repair'
  },
  {
    name: 'Churches',
    type: 'church',
    dir: 'churches'
  },
  {
    name: 'Clothing stores',
    type: 'clothing_store',
    dir: 'clothing-stores'
  },
  {
    name: 'Convenience stores',
    type: 'convenience_store',
    dir: 'convenience-stores'
  },
  {
    name: 'Dentists',
    type: 'dentist',
    dir: 'dentists'
  },
  {
    name: 'Doctors',
    type: 'doctor',
    dir: 'doctors'
  },
  {
    name: 'Electricians',
    type: 'electrician',
    dir: 'electricians'
  },
  {
    name: 'Electronics',
    type: 'electronics_store',
    dir: 'electronics'
  },
  {
    name: 'Fire Stations',
    type: 'fire_station',
    dir: 'fire-stations'
  },
  {
    name: 'Florists',
    type: 'florist',
    dir: 'florists'
  },
  {
    name: 'Furniture',
    type: 'furniture_store',
    dir: 'furniture'
  },
  {
    name: 'Petrol stations',
    type: 'gas_station',
    dir: 'petrol-stations'
  },
  {
    name: 'Gyms',
    type: 'gym',
    dir: 'gyms'
  },
  {
    name: 'Hardware stores',
    type: 'hardware_store',
    dir: 'hardware-stores'
  },
  {
    name: 'Hospitals',
    type: 'hospital',
    dir: 'hospitals'
  },
  {
    name: 'Laundry',
    type: 'laundry',
    dir: 'laundry'
  },
  {
    name: 'Solicitors',
    type: 'lawyer',
    dir: 'solicitors'
  },
  {
    name: 'Library',
    type: 'library',
    dir: 'library'
  },
  {
    name: 'Hotels',
    type: 'lodging',
    dir: 'hotels'
  },
  {
    name: 'Painters',
    type: 'painter',
    dir: 'painters'
  },
  {
    name: 'Pet stores',
    type: 'pet_store',
    dir: 'pet-stores'
  },
  {
    name: 'Chemists',
    type: 'pharmacy',
    dir: 'chemists'
  },
  {
    name: 'Plumbers',
    type: 'plumber',
    dir: 'plumbers'
  },
  {
    name: 'Police',
    type: 'police',
    dir: 'police'
  },
  {
    name: 'Post offices',
    type: 'post_office',
    dir: 'post-offices'
  },
  {
    name: 'Estate agents',
    type: 'real_estate_agency',
    dir: 'estate-agents'
  },
  {
    name: 'Restaurants',
    type: 'restaurant',
    dir: 'restaurants'
  },
  {
    name: 'Roofing',
    type: 'roofing_contractor',
    dir: 'roofing'
  },
  {
    name: 'Schools',
    type: 'school',
    dir: 'schools'
  },
  {
    name: 'Shoe stores',
    type: 'shoe_store',
    dir: 'shoe-stores'
  },
  {
    name: 'Stores',
    type: 'store',
    dir: 'stores'
  },
  {
    name: 'Travel agencies',
    type: 'travel_agency',
    dir: 'travel-agencies'
  },
  {
    name: 'Vets',
    type: 'veterinary_care',
    dir: 'vets'
  },
  {
    name: 'Night clubs',
    type: 'night_club',
    dir: 'night-clubs'
  },
  {
    name: 'Jewellery stores',
    type: 'jewelry_store',
    dir: 'jewellery-stores'
  },
];

export const LOCATION = 'Basildon';

export const DOMAIN = 'basildon-online.com';

export const MONTHS = ['Jan', 'Feb', 'March', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const ROOT_DIR = 'http://' + window.location.host;

export const ListAPIKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiODM3ZWM2NjktOTk4Ny00NmI2LWE4NmYtZThkMTg2MTAwMmVkIiwia2V5X2lkIjoiNzk2ZDBlOGItOTY5Ni00ZDllLWJhZWItOWFjNDAxN2Q1YTNiIiwiaWF0IjoxNTE1NjczMDc0fQ.ziGcQ6brCrrcEVsKtNkppwcbLyVXpBvCH1tQ6ta-mL0';



// WEBPACK FOOTER //
// ./src/utils/Constants.js